import { render, staticRenderFns } from "./ZoomNote.vue?vue&type=template&id=08cd9395&scoped=true&"
import script from "./ZoomNote.vue?vue&type=script&lang=js&"
export * from "./ZoomNote.vue?vue&type=script&lang=js&"
import style0 from "./ZoomNote.vue?vue&type=style&index=0&id=08cd9395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd9395",
  null
  
)

export default component.exports